import React, { useMemo, useState } from 'react';

import { Paragraph, SupportLink } from '@periodica/ui-kit';
import * as Select from '@periodica/ui-kit/simple-select';
import { matchSorter } from 'match-sorter';

const hardcodedCites = [
  '2', // Москва
  '4', // Санкт-Петербург
  '25', // Екатеринбург
  '29', // Казань
  '126', // Красногорск
  '34', // Краснодар
  '39', // Нижний Новгород
  '41', // Новосибирск
  '49', // Ростов-на-Дону
  '64', // Челябинск
];

export function SelectField({
  value,
  onChange,
  cities,
}: {
  value: string;
  onChange: (update: string) => void;
  cities: Record<string, { id: number; text: string }>;
}) {
  const [searchValue, setSearchValue] = useState('');

  const matches = useMemo(() => {
    if (searchValue === '') {
      return (!hardcodedCites.includes(value) ? [cities[value]] : [])
        .concat(hardcodedCites.map((id) => cities[id]))
        .filter(Boolean);
    }

    return matchSorter(Object.values(cities), searchValue, {
      keys: ['text'],
      baseSort: (a, b) => {
        const rank = a.rank - b.rank;
        if (rank !== 0) return rank;
        return a.index - b.index;
      },
      threshold: matchSorter.rankings.CONTAINS,
    }).slice(0, 10);
  }, [searchValue, cities, value]);

  return (
    <Select.Provider
      selectedValue={value}
      setSelectedValue={onChange}
      inputValue={searchValue}
      setInputValue={setSearchValue}
    >
      <Select.Select placeholder="Выберите город" variant="light">
        {cities[value]?.text}
      </Select.Select>

      <Select.Popover list={false}>
        <Select.SearchField placeholder="Найти город" />

        <Select.SearchList>
          {searchValue === '' && (
            <Paragraph size="small" color="secondary" style={{ padding: 8 }}>
              Вы можете выбрать еще из {Object.values(cities).length} населенных пунктов по всей
              России.
            </Paragraph>
          )}

          {matches.map(({ id, text }) => (
            <Select.Option key={id} value={`${id}`}>
              {text}
            </Select.Option>
          ))}

          {searchValue !== '' && (
            <Paragraph size="small" color="secondary" style={{ padding: 8 }}>
              Нет вашего города? <SupportLink>Свяжитесь с нами</SupportLink>.
            </Paragraph>
          )}
        </Select.SearchList>
      </Select.Popover>
    </Select.Provider>
  );
}
